import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Shell } from "@/components/Shell";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function NotFound() {
  const { t } = useTranslation();

  return (
    <Shell>
      <Card>
        <CardHeader>
          <CardTitle>{t("notFound.title")}</CardTitle>
          <CardDescription>
            {t("notFound.description")}
            <Link className="jb-link" to="/">
              {t("notFound.back")}
            </Link>
          </CardDescription>
        </CardHeader>
      </Card>
    </Shell>
  );
}
